import * as React from 'react'
import * as domain from '@packages/domain'
import styled, { css } from 'styled-components'
import { Col, Row } from 'react-bootstrap'
import { CategoryTitle } from '../components/CategoryTitle'
import { Screen } from '../commons'

export interface PlaceholderProps extends domain.Placeholder.Type {}

const Description = styled.div`
  margin-bottom: 1rem;

  &,
  & > p {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  & > p {
    margin-bottom: 0;
  }
`

const Container = styled(Row)`
  margin-bottom: 5rem;
  margin-top: 5rem;
  ${Screen.Desktop(css`
    border-left: 0.333333rem solid #bebebe;
  `)}
`

const PostContentWrapper = styled.div`
  position: relative;
  min-height: 100%;
  background-color: var(--light);
  padding: 2rem;
`

export const Placeholder: React.VFC<PlaceholderProps> = ({ title, description }) => {
  return (
    <Container>
      <Col xs="auto" lg={{ offset: 1 }}>
        <CategoryTitle name={title} icon={'fa-solid fa-square-question'} />
      </Col>
      <div className="w-100"></div>
      <Col sm={{ span: 7, offset: 4 }} lg={{ span: 6, offset: 4 }}>
        <PostContentWrapper>
          <Description dangerouslySetInnerHTML={{ __html: description }} />
        </PostContentWrapper>
      </Col>
    </Container>
  )
}
